import axios from "axios";
import React, { useState, useEffect } from "react";
import {
  Tabs,
  Form,
  Input,
  Button,
  Select,
  Upload,
  Checkbox,
  Modal,
  message
} from "antd";
import { useDrawer } from "../../../context/drawer";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { MdCancel } from "react-icons/md";
import imageCompression from "browser-image-compression";
const { Option } = Select;

export default function PackageUpdateForm() {
  const { drawerData, setDrawerData } = useDrawer();
  const [selectedColorId, setSelectedColorId] = useState(null);
  const [sizes, setSizes] = useState([]); // Initialize sizes as an empty array
  const [form] = Form.useForm();
  const { toggleDrawer } = useDrawer();
  const handleProductNameChange = (e) => {
    const productName = e.target.value;
    const slug = productName.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    form.setFieldsValue({ slug });
  };

  // new add on 
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [colorForm] = Form.useForm();
  const [sizeForm] = Form.useForm();


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://1fiveglobal.com/api/category.php?action=fetch&admin_token=OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH"
        );
        if (response.data.list) {
          setCategories(response.data.list || []);
        } else {
          message.error("Failed to fetch categories");
        }
      } catch (error) {
        message.error("Error fetching categories");
      }
    };

    fetchCategories();
  }, []);


  useEffect(() => {
    if (drawerData.value) {
      form.setFieldsValue({
        // product 
        product_name: drawerData?.value?.product_name,
        product_desc: drawerData?.value?.product_desc,
        category_id: drawerData?.value?.category_id,
        product_type: drawerData?.value?.product_type,
        slug: drawerData?.value?.slug,
        material: drawerData?.value?.material,
        care: drawerData?.value?.care,
        product_code: drawerData?.value?.product_code,
        Breadth: drawerData?.value?.Breadth,
        Height: drawerData?.value?.Height,
        Length: drawerData?.value?.Length,
        // color 
        color_code: drawerData?.value?.colors[0]?.color_code,
        color_name: drawerData?.value?.colors[0]?.color_name,
        product_price: drawerData?.value?.colors[0]?.product_price,
        product_qty: drawerData?.value?.colors[0]?.product_qty,
        color_code: drawerData?.value?.colors[0]?.color_code,
      });
      setSizes(drawerData.value?.size || []); // Set sizes with a fallback to an empty array
    }

    if (drawerData.value.colors.length >= 0) {
      setSelectedColorId(drawerData?.value?.colors[0]?.color_id),
        colorForm.setFieldsValue({
          // color 
          color_code: drawerData?.value?.colors[0]?.color_code,
          color_id: drawerData?.value?.colors[0]?.color_id,
          color_name: drawerData?.value?.colors[0]?.color_name,
          product_price: drawerData?.value?.colors[0]?.product_price,
          product_qty: drawerData?.value?.colors[0]?.product_qty,
          color_code: drawerData?.value?.colors[0]?.color_code,
        });
    }

    if (drawerData?.value?.colors?.length > 0 || drawerData?.value?.colors[0]?.sizes?.length > 0) {
      setSizes(drawerData?.value?.colors[0]?.sizes)
      sizeForm.setFieldsValue({
        color_id: drawerData?.value?.colors[0]?.color_id,
        // color_code: drawerData?.value?.colors[0]?.color_code,
      })
    }

    if (drawerData?.value?.colors?.length > 0 || drawerData?.value?.colors[0]?.images?.length > 0) {
      const formattedImages = drawerData?.value?.colors[0]?.images?.map((img, index) => ({
        uid: img.img_id || `-img-${index}`,
        name: `image-${index + 1}.jpg`,
        status: "done",
        url: img.images, // Ensure the correct key for image URL
      }));
      setFileList(formattedImages);
    }
  }, [drawerData, form]);


  const handleProductSubmit = async (values) => {
    console.log("values", values)
    setLoading(true);
    const formData = new FormData();
    formData.append("action", "updateProduct");
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
    formData.append("product_Id", drawerData?.value?.product_Id);
    formData.append("product_name", values.product_name);
    formData.append("product_desc", values.product_desc);
    formData.append("category_id", values.category_id);
    formData.append("product_type", values.product_type);
    formData.append("slug", values.slug);
    formData.append("material", values.material);
    formData.append("care", values.care);
    formData.append("product_code", values.product_code);
    formData.append("Breadth", values.Breadth);
    formData.append("Height", values.Height);
    formData.append("Length", values.Length);
    formData.append("delivery_charges", "0");
    formData.append("out_stock", "1");

    try {
      const response = await axios.post(
        "https://1fiveglobal.com/api/product.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status <= 300) {
        toggleDrawer();
        message.success(response.data.status);
      } else {
        message.error(response.data.status || "Failed to add product");
      }
    } catch (error) {
      console.log("error", error)
      // message.error(error);

    }
    setLoading(false);

  }


  const handleColorSubmit = async (values) => {
    console.log('values', values)
    setLoading(true);
    const formData = new FormData();
    formData.append("action", "updateColor");
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
    formData.append("color_code", values.color_code);
    formData.append("color_name", values.color_name);
    formData.append("product_price", values.product_price);
    formData.append("product_qty", values.product_qty);
    formData.append("color_id", values.color_id);

    try {
      const response = await axios.post(
        "https://1fiveglobal.com/api/product.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status >= 200 && response.status <= 300) {
        toggleDrawer();
        message.success(response.data.status);
      } else {
        message.error(response.data.status || "Failed to add color");
      }
    } catch (error) {
      console.log("error", error)
      // message.error(error);
    }
    setLoading(false);

  }


  // SIZE 


  // Add new size field
  const addSizeField = () => {
    setSizes([...sizes, { size_id: Date.now(), product_size: "", qty: "", price: "", out_of_stock: false }]);
  };

  // Handle input changes
  const handleSizeChange = (index, field, value) => {
    const updatedSizes = [...sizes];
    updatedSizes[index][field] = value;
    setSizes(updatedSizes);
  };

  // Remove size field by index
  const removeSizeField = (index) => {
    const updatedSizes = sizes.filter((_, i) => i !== index);
    setSizes(updatedSizes);
  };

  // Submit sizes
  const handleSizeSubmit = async (values) => {
    console.log("sizes", sizes)

    setLoading(true);
    const formData = new FormData();
    formData.append("action", "updateSized");
    formData.append("color_id", values.color_id);
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
    sizes.forEach((size, index) => {
      formData.append("size_id[]", size.size_id);
      formData.append("product_size[]", size.product_size);
      formData.append("qty[]", size.qty);
      formData.append("price[]", size.price);
      formData.append("out_of_stock[]", size.out_of_stock ? "1" : "0");
    });


    try {
      const response = await axios.post(
        "https://1fiveglobal.com/api/product.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status <= 300) {
        toggleDrawer();
        message.success(response.data.status);
      } else {
        message.error(response.data.status || "Failed to add size");
      }
    } catch (error) {
      console.log("error", error)
      message.error("Error submitting size");
    }
    setLoading(false);
  };


  // images updtaes 

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [newImages, setNewImages] = useState([]); // To store new images


  // Image Compression Function
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.5, // Target size in MB
      maxWidthOrHeight: 800, // Max dimensions
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      console.log("Compressed File:", compressedFile);
      return compressedFile;
    } catch (error) {
      console.error("Compression error:", error);
      throw error; // Let the calling function handle this
    }
  };


  const handleChange = async ({ fileList: newFileList }) => {
    const updatedFileList = [];
    const newImagesList = [];

    for (const file of newFileList) {
      if (file.status !== "done" && file.originFileObj) {
        try {
          const compressedFile = await compressImage(file.originFileObj);

          if (!compressedFile) {
            throw new Error("Compression returned an invalid file");
          }

          const newFile = new File([compressedFile], file.name, { type: file.type });
          const updatedFile = { ...file, originFileObj: newFile };

          updatedFileList.push(updatedFile); // UI list
          newImagesList.push(updatedFile);  // New images for upload

        } catch (error) {
          console.error("Image compression failed:", error);
          message.error("Image compression failed, using original image.");
          updatedFileList.push(file); // Use the original file if compression fails
        }
      } else {
        updatedFileList.push(file); // Keep existing images
      }
    }

    setFileList(updatedFileList);  // Update UI list
    setNewImages(newImagesList);   // Store new images for upload
  };



  // Handle image upload to API
  const handleImageUpload = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("action", "AddImages");
    formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
    formData.append("color_id", selectedColorId);
    // Add only new images to API request
    newImages.forEach((file) => {
      formData.append("images[]", file.originFileObj);
    });

    try {
      const response = await axios.post("https://1fiveglobal.com/api/product.php", formData);

      if (response.status >= 200 && response.status <= 300) {
        message.success(response.data.status);
        toggleDrawer();
        setNewImages([]); // Reset new images after upload
        setFileList([]); // Reset new images state after upload
      } else {
        message.error(response.data.status || "Failed to upload images");
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Error uploading images");
    } finally {
      setLoading(false);
    }
  };


  // images delete 
  // Handle image removal
  const handleRemoveImage = async (file) => {
    console.log("file", file)
    if (!file.uid) return;

    // Extract the image ID
    const imgId = file.uid.startsWith("-img-") ? null : file.uid; // Ensure we only remove stored images

    if (!imgId) {
      setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "removeImage");
      formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
      formData.append("img_id", imgId);

      const response = await axios.post("https://1fiveglobal.com/api/product.php", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status >= 200 && response.status <= 300) {
        message.success("Image removed successfully");
        setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
      } else {
        message.error(response.data.status || "Failed to remove image");
      }
    } catch (error) {
      console.error("Remove Error:", error);
      message.error("Error removing image");
    } finally {
      setLoading(false);
    }
  };



  // Tabs items
  const items = [
    {
      key: "1",
      label: "Product",
      children: (
        <div className="product">
          <Form form={form} onFinish={handleProductSubmit} layout="vertical">
            <Form.Item name="product_name" label="Product Name" rules={[{ required: true, message: "Please enter product name" }]}>
              <Input placeholder="Enter product name" onChange={handleProductNameChange} />
            </Form.Item>
            <Form.Item name="product_desc" label="Product Description" rules={[{ required: true, message: "Please enter product description" }]}>
              <Input.TextArea placeholder="Enter product description" />
            </Form.Item>
            <Form.Item name="category_id" label="Category" rules={[{ required: true, message: "Please select a category" }]}>
              <Select placeholder="Select category">
                {categories.map((category) => (
                  <Option key={category.category_Id} value={category.category_Id}>
                    {`${category.category_name} (${category.gander})`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="product_type" label="Product Type" rules={[{ required: true, message: "Please select product type" }]}>
              <Input placeholder="Enter Product Type" />
            </Form.Item>
            <Form.Item name="material" label="Product Material" rules={[{ required: true, message: "Please select product material" }]}>
              <Input placeholder="Enter Product Material" />
            </Form.Item>
            <Form.Item name="care" label="Product care" rules={[{ required: true, message: "Please select product care" }]}>
              <Input placeholder="Enter Product care" />
            </Form.Item>
            <Form.Item name="product_code" label="Product code" rules={[{ required: true, message: "Please select product code" }]}>
              <Input placeholder="Enter Product code" />
            </Form.Item>
            <Form.Item name="Breadth" label="Box Breadth" rules={[{ required: true, message: "Please Enter Box Breadth" }]}>
              <Input placeholder="Enter Box Breadth" />
            </Form.Item>
            <Form.Item name="Height" label="Box Height" rules={[{ required: true, message: "Please Enter Box Height" }]}>
              <Input placeholder="Enter Box Height" />
            </Form.Item>
            <Form.Item name="Length" label="Box Length" rules={[{ required: true, message: "Please Enter Box Length" }]}>
              <Input placeholder="Enter Box Length" />
            </Form.Item>
            <Form.Item name="slug" label="Slug" rules={[{ required: true, message: "Please enter slug" }]}>
              <Input placeholder="Slug auto generated from product name" disabled />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">Submit</Button>
            </Form.Item>
          </Form>
        </div>
      ),
    },
    {
      key: "2",
      label: "color",
      children: (
        <div className="size">
          <Form form={colorForm} onFinish={handleColorSubmit} layout="vertical">
            <Form.Item name="color_id" label="Color id" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="color_code" label="Color Code" rules={[{ required: true, message: "Please enter color code" }]}>
              <Input placeholder="#FF5733" />
            </Form.Item>
            <Form.Item name="color_name" label="Color Name" rules={[{ required: true, message: "Please enter color name" }]}>
              <Input placeholder="Red" />
            </Form.Item>
            <Form.Item name="product_price" label="Price" rules={[{ required: true, message: "Please enter product price" }]}>
              <Input placeholder="49.99" />
            </Form.Item>
            <Form.Item name="product_qty" label="Quantity" rules={[{ required: true, message: "Please enter quantity" }]}>
              <Input placeholder="100" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>Submit Color</Button>
            </Form.Item>
          </Form>
        </div>
      ),
    },
    {
      key: "3",
      label: "Size",
      children: (
        <>

          <Button onClick={addSizeField} style={{ margin: "20px 0px" }}>
            Add Size
          </Button>
          <Form form={sizeForm} onFinish={handleSizeSubmit} layout="vertical">
            <Form.Item name="color_id" hidden>
              <Input />
            </Form.Item>
            {sizes.map((size, index) => (
              <div key={size.id}>
                <div className="row updtae-row-con">
                  <div className="col-12" style={{ display: "none" }}>
                    <Input
                      placeholder="size_id"
                      value={size.size_id}
                      onChange={(e) => handleSizeChange(index, "size_id", e.target.value)}
                    />
                  </div>
                  <div className="col-2">
                    <Input
                      placeholder="Size"
                      value={size.product_size}
                      onChange={(e) => handleSizeChange(index, "product_size", e.target.value)}
                    />
                  </div>
                  <div className="col-2">
                    <Input
                      placeholder="Quantity"
                      value={size.qty}
                      onChange={(e) => handleSizeChange(index, "qty", e.target.value)}
                    />
                  </div>
                  <div className="col-3">
                    <Input
                      placeholder="Price"
                      value={size.price}
                      onChange={(e) => handleSizeChange(index, "price", e.target.value)}
                    />
                  </div>
                  <div className="col-3">
                    <Checkbox
                      checked={size.out_of_stock == "1"}
                      onChange={(e) => handleSizeChange(index, "out_of_stock", e.target.checked)}
                    >
                      In Stock
                    </Checkbox>
                  </div>
                  <div className="col-2">
                    <div className="update-product-main-cancel-icons" onClick={() => removeSizeField(index)}>
                      <MdCancel />
                    </div>

                  </div>
                </div>
              </div>
            ))}
            <Button type="primary" htmlType="submit" loading={loading} style={{ marginTop: 20 }}>
              Submit Sizes
            </Button>
          </Form>
        </>
      ),
    },
    {
      key: "4",
      label: "Images",
      children: (
        <>
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={(file) => {
              setPreviewImage(file.url || file.thumbUrl);
              setPreviewOpen(true);
            }}
            beforeUpload={() => false}
            onChange={handleChange}
            onRemove={handleRemoveImage}  // <-- Use the updated function
          >
            {fileList.length >= 8 ? null : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            )}
          </Upload>

          <Modal open={previewOpen} footer={null} onCancel={() => setPreviewOpen(false)}>
            <img alt="preview" style={{ width: "100%" }} src={previewImage} />
          </Modal>

          <Button type="primary" onClick={handleImageUpload} loading={loading} style={{ marginTop: 20 }}>
            Upload Images
          </Button>
        </>
      )
    }
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      items={items}
    />
  );
}